export default {
  /*
    use this namespace to translate response from network respond events
    e.g.
    backend_errors: {
      createCompanyConstant: {
        1: 'Company does not exist',
      }
    },
  */
  0: 'Check your connection',
  401: 'You don\'t have access',
};
